import { Dialog } from 'primereact/dialog'
import utils from '../../../../utils'
import { Button } from 'primereact/button'
import { enums, icons } from '../../../../constants'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import LtsTextArea from '../../../../components/lottus/lts-text-area'
import LtsLookupPessoa from '../../../../components/lottus/lts-lookup-pessoa'

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function EmitirNfseDialog(props) {
  const [pagador, setPagador] = useState(null)

  useEffect(() => {
    resetValues()
    initPagador()
  }, [props.visible])

  const initPagador = () => {
    setPagador(_.get(props.record, 'pagador', null))
  }

  const onHide = () => {
    props.onHide()
  }

  const onConfirm = () => {
    props.onConfirm({
      oidLancamento: props.record.oid,
      descricaoNFSe: props.record.descricaoServicoNFSe,
      oidPagador: _.get(pagador, 'id', null),
    })
    onHide()
  }

  const resetValues = () => {
    setPagador(null)
  }

  return (
    <Dialog
      header={utils.getMessage(props.messages, 'lancamentofinanceiro.label.emitirNfse')}
      visible={props.visible}
      style={{ width: '30vw' }}
      onHide={() => {
        onHide()
      }}
      baseZIndex={1000000}
      modal={true}
      closable={true}
    >
      <div style={{ marginTop: '20px' }} className="p-grid p-fluid">
        <div className="form-group p-col-12">
          <LtsTextArea
            value={_.get(props.record, 'descricaoServicoNFSe', null)}
            onChange={(e) => props.setField('descricaoServicoNFSe', e)}
            name={'descricaoServicoNFSe'}
            label={utils.getMessage(props.messages, 'lancamentofinanceiro.label.emitirNfse.descricaoNfse')}
          />
          {utils.hasVariaveisEmissaoNfse(_.get(props.record, 'descricaoServicoNFSe', null)) && (
            <small>{utils.getMessage(props.messages, 'lancamentofinanceiro.label.descricaoServicoNFSe.help')}</small>
          )}
        </div>
        <div className="form-group p-col-12">
          <LtsLookupPessoa
            header={'Pagador'}
            name={'pagador'}
            field={'nome'}
            label={utils.getMessage(props.messages, 'lancamentofinanceiro.label.pagador')}
            value={{
              id: _.get(pagador, 'id', null),
              value: _.get(pagador, 'value', null),
            }}
            oidRecord={_.get(pagador, 'id', '')}
            history={props.history}
            onChange={(e) => setPagador({ id: e.oid, value: e.nome })}
            statePessoaFisica={props.statePessoaFisica}
            statePessoaJuridica={props.statePessoaJuridica}
            tipoPessoa={enums.TipoPessoa.AMBAS}
            showAddButton={false}
            editHidden={true}
          />
        </div>
      </div>
      <div style={{ marginTop: '20px' }} className="p-grid form-group">
        <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
          <Button
            label={utils.getMessage(props.messages, 'lancamentofinanceiro.label.emitirNfse.emitir')}
            onClick={() => {
              onConfirm()
            }}
            icon={icons.CHECK_ICON}
            className="p-button-success"
          />
        </div>
      </div>
    </Dialog>
  )
}
